export const INSERT_IMAGE_BUTTON = 'insert-image-button';

export const PLUGIN_TOOLBAR_LINK_BUTTON = 'plugin-toolbar-link-button';
export const PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON = 'plugin-toolbar-button-image-editor';

export const ROOT = 'image-viewer';
export const EXPAND_BUTTON = 'image-expand-button';

export const SETTINGS_MODAL = 'image-settings-modal';
export const SETTINGS_IMAGE_PREVIEW = 'settings-image-preview';
export const SETTINGS_ALT_INPUT = 'settings-alt-input';
export const SETTINGS_DISABLE_EXPAND_TOGGLE = 'settings-expand-toggle';
export const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = 'settings-download-toggle';
export const SETTINGS_SPOILER_TOGGLE = 'settings-spoiler-toggle';
export const SETTINGS_IS_DECORATIVE_TOGGLE = 'settings-is-decorative-toggle';
export const SETTINGS_IMAGE_TABS = 'settings-image-tabs';
export const SETTINGS_DESIGN_TAB_BORDER_WIDTH_SLIDER = 'settings-image-border-width-slider';
export const SETTINGS_DESIGN_TAB_BORDER_WIDTH_INPUT = 'settings-image-border-width-input';
export const SETTINGS_DESIGN_TAB_BORDER_COLOR_PICKER = 'settings-image-border-color-picker';
export const SETTINGS_DESIGN_TAB_CORNER_RADIUS_SLIDER = 'settings-image-corner-radius-slider';
export const SETTINGS_DESIGN_TAB_CORNER_RADIUS_INPUT = 'settings-image-corner-radius-input';
